export interface ExternalProvidersConfiguration {
  hasFlightBridge: boolean;
  hasFlightDocs: boolean;
  hasForeFlightIntegration: boolean;
  hasFuelerLinks: boolean;
  hasPolaris: boolean;
  isAdmin: boolean;
  isLockTripEnabled: boolean;
  defaultTripStatusId: number | null;
}

export const DEFAULT_EXTERNAL_PROVIDERS_CONFIGURATION: ExternalProvidersConfiguration = {
  hasFlightBridge: false,
  hasFlightDocs: false,
  hasForeFlightIntegration: false,
  hasFuelerLinks: false,
  hasPolaris: false,
  isAdmin: false,
  isLockTripEnabled: false,
  defaultTripStatusId: 1
};
